var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TicketCard',{attrs:{"ticket":_vm.ticket},on:{"click":function($event){return _vm.ticketClicked()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }